import { ChangeEvent, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  SelfieRequirementsSections,
  ShowTakenSelfie
} from '@/components/ProfileData/Selfie/parts/parts.tsx';
import { FileData } from '@/shared/interface/userRegistrationData.ts';
import { PhotoKind, UserSelfieProps } from '@/shared/type/userDataFields.ts';
import { MainButton } from '@/components/common/MainButton/MainButton.tsx';

export function IosUserSelfie({
  selfie,
  updateFields,
  isSubmitting
}: UserSelfieProps) {
  const [takenSelfie, setTakenSelfie] = useState<FileData | null>(
    selfie || null
  );
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleCapture = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const selfieFile = {
        file: file,
        url: {
          [PhotoKind.KIND_PRIMARY]: URL.createObjectURL(file),
          [PhotoKind.KIND_THUMB]: URL.createObjectURL(file)
        },
        hid: Date.now().toString()
      };
      setTakenSelfie(selfieFile);
      updateFields({ selfie: selfieFile });
    }
  };

  const handleRetake = () => {
    fileInputRef.current?.click();
  };

  const { t } = useTranslation();

  const renderInitialState = () => (
    <>
      <SelfieRequirementsSections />
      <MainButton
        text={t('button.take_photo')}
        fixed
        onClick={() => fileInputRef.current?.click()}
      />
    </>
  );

  const renderTakenSelfieState = () => (
    <ShowTakenSelfie
      takenSelfie={takenSelfie}
      handleRetake={handleRetake}
      isSubmitting={isSubmitting}
    />
  );

  return (
    <div>
      {takenSelfie ? renderTakenSelfieState() : renderInitialState()}
      <input
        id="cameraFileInput"
        type="file"
        accept="image/*"
        capture="user"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleCapture}
      />
    </div>
  );
}
